
//https://web.noron1.ir/map?lat=35.6892&lng=51.3890
//https://web.noron1.ir/map?loc=35.6892,51.3890
//https://web.noron1.ir/map/35.6892/51.3890
//https://web.noron1.ir/map/35.6892,51.3890


import React, { useContext, useEffect, useState, useMemo, useRef } from "react";
import {
    MapContainer, Marker, Popup, useMapEvents, useMap

} from 'react-leaflet'
import L from 'leaflet';
import AddTileLayer from './AddTileLayer'
import carIcon from '../Images/car1.png'
import { toast } from "react-toastify";
import loginLogo from '../Images/logoWeb.png'
import { Link, useParams } from "react-router-dom";


function FlyToLocation({ loc }) {
    const map = useMap();

    useEffect(() => {
        if (loc) {
            map.flyTo([loc.latitude, loc.longitude], 16, {
                duration: 2
            });
        }
    }, [loc]);

    return null;
}
export default function MapOffline() {
    const [isPosting, setIsPosting] = useState(true);
    const [loc, setLoc] = useState(null)
    const [address, setAddress] = useState("")
    const { lat, lng, coords } = useParams();
    const [showInput, setShowInput] = useState(true)
    useEffect(() => {
        if (lat && lng) {
            setLoc({
                latitude: parseFloat(lat),
                longitude: parseFloat(lng)
            });
            return;
        }

        if (coords) {
            const result = extractLatLng(coords);
            if (result) {
                setLoc(result);
            }
        }

    }, [lat, lng, coords]);

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);

        // حالت loc=lat,lng
        const locParam = params.get("loc");
        if (locParam) {
            const result = extractLatLng(locParam);
            if (result) {
                setLoc(result);
                setShowInput(false)
                return;
            }
        }

        // حالت lat & lng
        const lat = params.get("lat");
        const lng = params.get("lng");

        if (lat && lng) {
            setLoc({
                latitude: parseFloat(lat),
                longitude: parseFloat(lng)
            });
            setShowInput(false)
        }

    }, []);

    const extractLatLngBase = (text) => {
        const regex = /place\/(-?\d+\.\d+),(-?\d+\.\d+)/;
        const match = text.match(regex);
        if (match) {
            return {
                latitude: parseFloat(match[1]),
                longitude: parseFloat(match[2])
            };
        }

        return null;
    };
    const extractLatLng = (text) => {
        // 1) حالت place/lat,lng
        let regex1 = /place\/(-?\d+\.\d+),(-?\d+\.\d+)/;
        let m1 = text.match(regex1);
        if (m1) {
            return { latitude: parseFloat(m1[1]), longitude: parseFloat(m1[2]) };
        }

        // 2) حالت @lat,lng,z
        let regex2 = /@(-?\d+\.\d+),(-?\d+\.\d+)(?:,|\b)/;
        let m2 = text.match(regex2);
        if (m2) {
            return { latitude: parseFloat(m2[1]), longitude: parseFloat(m2[2]) };
        }

        // 3) حالت q=lat,lng
        let regex3 = /[?&]q=(-?\d+\.\d+),(-?\d+\.\d+)/;
        let m3 = text.match(regex3);
        if (m3) {
            return { latitude: parseFloat(m3[1]), longitude: parseFloat(m3[2]) };
        }

        // 4) حالت query=lat,lng
        let regex4 = /[?&]query=(-?\d+\.\d+),(-?\d+\.\d+)/;
        let m4 = text.match(regex4);
        if (m4) {
            return { latitude: parseFloat(m4[1]), longitude: parseFloat(m4[2]) };
        }

        // 5) حالت loc:lat,lng
        let regex5 = /loc:(-?\d+\.\d+),(-?\d+\.\d+)/;
        let m5 = text.match(regex5);
        if (m5) {
            return { latitude: parseFloat(m5[1]), longitude: parseFloat(m5[2]) };
        }

        // 6) حالت فقط "lat,lng"
        let regex6 = /(-?\d+\.\d+)\s*,\s*(-?\d+\.\d+)/;
        let m6 = text.match(regex6);
        if (m6) {
            return { latitude: parseFloat(m6[1]), longitude: parseFloat(m6[2]) };
        }

        return null;
    };


    const doParseAddress = (e) => {
        e.preventDefault();

        const result = extractLatLng(address);

        if (result) {
            setLoc(result);
        } else {
            toast.error("مختصات در متن پیدا نشد");
        }
    }
    const MapPlaceholder = () => {
        return (
            <p>
                نمایش نقشه
                <noscript>You need to enable JavaScript to see this map.</noscript>
            </p>
        )
    }
    return (
        <div className="vh-100 d-flex flex-column">

            {/* فرم بالا */}
            <div className="container pt-3 pb-2">
                <div className="row mt-1 ">
                    <div className="col d-flex  justify-content-center">
                        <img src={loginLogo} className="img-fluid" alt="logo" style={{ width: "100px" }} />
                    </div>
                </div>
                <div className="row ">
                    <div className="col fs-4 text-color1 d-flex  justify-content-center align-items-center">
                        <p>
                            سامانه
                            <span className='fw-bold mx-1 fs-2'> نورون </span>
                        </p>
                    </div>
                </div>
                {showInput &&
                    <>
                        <div className="row  ">
                            <div className="col">
                                <textarea
                                    className="form-control"
                                    rows={4}
                                    value={address}
                                    onChange={(e) => setAddress(e.target.value)}
                                    placeholder="متنی که از سمت دستگاه برای شما ارسال شده اینجا وارد کنید"
                                />
                            </div>
                        </div>

                        <div className="row mt-2">
                            <div className="col">
                                <button
                                    className="btn btn-primary"
                                    onClick={doParseAddress}
                                >
                                    نمایش موقعیت خودرو
                                </button>
                            </div>
                            <div className="col d-flex align-items-center">
                                <Link
                                    to="/">ورود به سامانه</Link>
                            </div>
                        </div>
                    </>
                }
            </div>

            {/* نقشه */}
            <div className="flex-fill">
                <MapContainer
                    center={[32, 53]}
                    zoom={6}
                    className="w-100 h-100"
                    zoomControl={true}
                >
                    <AddTileLayer />

                    {loc && <FlyToLocation loc={loc} />}

                    {loc &&
                        <Marker
                            position={[loc.latitude, loc.longitude]}
                            icon={new L.icon({
                                iconUrl: carIcon,
                                iconSize: [50, 50],
                            })}
                        >
                            <Popup>
                                موقعیت خودرو
                            </Popup>
                        </Marker>
                    }

                </MapContainer>
            </div>

        </div>
    );


}